import { logo } from "../../assets";

const ErrorPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f1f3f5",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
      }}
    >
      {/* Logo */}
      <img
        src={logo}
        alt="LAM-KPRS Logo"
        style={{ height: "70px", marginBottom: "2rem" }}
      />

      {/* Card Container */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "1rem",
          boxShadow: "0 12px 40px rgba(0,0,0,0.08)",
          maxWidth: "720px",
          width: "100%",
          padding: "3rem 2.5rem",
          textAlign: "center",
        }}
      >
        {/* Heading */}
        <h1
          style={{
            fontSize: "2.25rem",
            fontWeight: "700",
            color: "#212529",
            marginBottom: "0.5rem",
          }}
        >
          Selamat Datang di
        </h1>

        <h2
          style={{
            color: "#0d6efd",
            fontWeight: "700",
            letterSpacing: "0.01em",
            fontSize: "3rem",
            marginBottom: "0.75rem",
          }}
        >
          S&nbsp;P&nbsp;E&nbsp;A&nbsp;K&nbsp;&nbsp;H&nbsp;O&nbsp;S&nbsp;P&nbsp;I&nbsp;T&nbsp;A&nbsp;L
        </h2>

        <p
          style={{
            color: "#6c757d",
            fontStyle: "italic",
            marginBottom: "1.75rem",
            fontSize: "1rem",
          }}
        >
          Sistem Pengelolaan Akreditasi LAM-KPRS
        </p>

        {/* Description */}
        <p
          style={{
            fontSize: "1.125rem",
            lineHeight: "1.75",
            color: "#495057",
            marginBottom: "2rem",
          }}
        >
          <strong>SPEAK HOSPITAL</strong> adalah platform digital terintegrasi yang dikembangkan oleh <strong>LAM-KPRS</strong> untuk mendukung proses akreditasi Rumah Sakit dan kegiatan Surveior secara efisien, terdokumentasi, dan transparan.
        </p>

        {/* CTA / Panduan */}
        <div style={{ marginBottom: "2.25rem" }}>
          <p style={{ fontSize: "1rem", color: "#495057", lineHeight: "1" }}>
            Untuk panduan instalasi dan penggunaan web aplikasi silahkan klik&nbsp;
            <a
              href="https://drive.google.com/drive/folders/1Lb00mSP0m3xDpeooCMSYS2oCNySr8MGF?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#0d6efd",
                textDecoration: "underline",
              }}
            >
              link petunjuk berikut
            </a>
            .
          </p>
        </div>

        <hr
          style={{
            width: "20%",
            margin: "2rem auto",
            opacity: 0.4,
            borderTop: "1px solid #dee2e6",
          }}
        />

        {/* Quote */}
        <p
          style={{
            fontStyle: "italic",
            color: "#6c757d",
            fontSize: "0.95rem",
            marginBottom: "0",
          }}
        >
          "Bersama menuju mutu pelayanan rumah sakit yang unggul melalui akreditasi terstandarisasi."
        </p>
      </div>

      {/* Footer */}
      <footer
        style={{
          marginTop: "2rem",
          fontSize: "0.8rem",
          color: "#adb5bd",
          textAlign: "center",
        }}
      >
        © {new Date().getFullYear()} LAM-KPRS
      </footer>
    </div>
  );
};

export default ErrorPage;

